/**
 * Ensures datetime strings on daily routes (day.date, point.startDate/endDate)
 * end with "Z" so that new Date() parses them as UTC, not local time.
 *
 * The websocket sync_payload and the sync-route HTTP response may send dates
 * as "2026-05-12T10:00:00" (no timezone). Without "Z", new Date() interprets
 * them as local time, which breaks UTC-based slot calculations in the timeline.
 *
 * HRS-2658: only full datetimes (with "T") get the "Z". Date-only strings like
 * day.date ("2026-07-17") must stay untouched — appending "Z" produced
 * "2026-07-17Z", which V8 tolerates but the backend's pydantic `date` parser
 * rejects, turning every sync after the first one into a 422.
 */
export function normalizeUtcDatesInDailyRoutes(dailyRoutes: any[]): any[] {
  return dailyRoutes.map(day => ({
    ...day,
    date: appendZIfMissing(day.date),
    points: day.points?.map(point => ({
      ...point,
      startDate: appendZIfMissing(point.startDate),
      endDate: appendZIfMissing(point.endDate),
    })) ?? []
  }));
}

function appendZIfMissing(value: unknown): unknown {
  if (typeof value !== 'string') return value;
  if (!value.includes('T')) return value; // date-only ("2026-07-17"): no timezone to normalize
  if (value.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(value)) return value;
  return value + 'Z';
}
